module.exports = __webpack_public_path__ + "img/winerack07.0bc3dbd8.jpg";